var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BaseComponent, BaseComponentPlus } from "react-vextensions";
import { Row, Column } from "react-vcomponents";
import Moment from "moment";
import { ScrollView } from "react-vscrollview";
import { Link, PageContainer, Observer } from "vwebapp-framework";
import { ES } from "Utils/UI/GlobalStyles";
import { ToNumber, E } from "js-vextensions";
import { GetUsers, GetSelectedUser, GetUserJoinDate, GetUserExtraInfo } from "Store/firebase/users";
import { UserProfileUI } from "./Users/UserProfile";
export const columnWidths = [0.35, 0.15, 0.1, 0.15, 0.25];
let UsersUI = class UsersUI extends BaseComponentPlus({}, {}) {
    render() {
        let users = GetUsers();
        // const userExtraInfoMap = GetUserExtraInfoMap();
        const selectedUser = GetSelectedUser();
        // if (userExtraInfoMap == null) return <div/>;
        if (selectedUser) {
            return React.createElement(UserProfileUI, { profileUser: selectedUser });
        }
        users = users.filter(a => a);
        /* users = users.OrderBy((a) => (userExtraInfoMap[a._key] ? userExtraInfoMap[a._key].joinDate : Number.MAX_SAFE_INTEGER));
        users = users.OrderByDescending((a) => (userExtraInfoMap[a._key] ? (userExtraInfoMap[a._key].edits | 0) : Number.MIN_SAFE_INTEGER)); */
        users = users.OrderBy(a => ToNumber(GetUserJoinDate(a._key), Number.MAX_SAFE_INTEGER));
        users = users.OrderByDescending(a => ToNumber(GetUserExtraInfo(a._key)?.edits, 0));
        return (React.createElement(PageContainer, { style: { padding: 0, background: null } },
            React.createElement(Column, { className: "clickThrough", style: { height: 40, background: "rgba(0,0,0,.7)", borderRadius: "10px 10px 0 0" } },
                React.createElement(Row, { style: { height: 40, padding: 10 } },
                    React.createElement("span", { style: { flex: columnWidths[0], fontWeight: 500, fontSize: 17 } }, "Name"),
                    React.createElement("span", { style: { flex: columnWidths[1], fontWeight: 500, fontSize: 17 } }, "Joined"),
                    React.createElement("span", { style: { flex: columnWidths[2], fontWeight: 500, fontSize: 17 } }, "Edits"),
                    React.createElement("span", { style: { flex: columnWidths[3], fontWeight: 500, fontSize: 17 } }, "Last edit"),
                    React.createElement("span", { style: { flex: columnWidths[4], fontWeight: 500, fontSize: 17 } }, "Permissions"))),
            React.createElement(ScrollView, { style: ES({ flex: 1 }), contentStyle: ES({ flex: 1 }) },
                users.length == 0 && React.createElement("div", { style: { textAlign: "center", fontSize: 18 } }, "Loading..."),
                users.map((user, index) => {
                    // const userExtraInfo = userExtraInfoMap[user._key];
                    const userExtraInfo = GetUserExtraInfo(user._key);
                    return React.createElement(UserRow, { key: user._key, index: index, last: index == users.length - 1, user: user, userExtraInfo: userExtraInfo });
                }))));
    }
};
UsersUI = __decorate([
    Observer
], UsersUI);
export { UsersUI };
let UserRow = class UserRow extends BaseComponent {
    render() {
        const { index, last, user, userExtraInfo } = this.props;
        if (userExtraInfo == null)
            return React.createElement("div", null);
        let { displayName } = user;
        if (displayName.includes("@"))
            displayName = displayName.split("@")[0];
        return (React.createElement(Column, { p: "7px 10px", style: E({ background: index % 2 == 0 ? "rgba(30,30,30,.7)" : "rgba(0,0,0,.7)" }, last && { borderRadius: "0 0 10px 10px" }) },
            userExtraInfo == null && React.createElement("div", { style: { textAlign: "center" } }, "Loading..."),
            userExtraInfo
                && React.createElement(Row, null,
                    React.createElement(Link, { text: displayName, actionFunc: s => s.main.users.selectedUserID = user._key, style: { flex: columnWidths[0], fontSize: 17 } }),
                    React.createElement("span", { style: { flex: columnWidths[1] } }, Moment(userExtraInfo.joinDate).format("YYYY-MM-DD")),
                    React.createElement("span", { style: { flex: columnWidths[2] } }, userExtraInfo.edits || 0),
                    React.createElement("span", { style: { flex: columnWidths[3] } }, userExtraInfo.lastEditAt ? Moment(userExtraInfo.lastEditAt).format("YYYY-MM-DD") : "n/a"),
                    React.createElement("span", { style: { flex: columnWidths[4] } }, ["basic", "verified", "mod", "admin"].filter(a => (userExtraInfo.permissionGroups || {})[a]).map(a => a.replace(/^./, a => a.toUpperCase())).join(", ")))));
    }
};
UserRow = __decorate([
    Observer
], UserRow);
